import React from "react";
import Menu from "@mui/joy/Menu";
import MenuButton from "@mui/joy/MenuButton";
import MenuItem from "@mui/joy/MenuItem";
import Dropdown from "@mui/joy/Dropdown";
import { NavLink } from "react-router-dom";

const LoginHeader = () => {
  return (
    <div>
      {" "}
      <div className=" row p-3" style={{ backgroundColor: "#D1E9F6" }}>
        {" "}
        <div className=" col-md-10">
          <h4 className="text-dark fw-bold">
            अहिल्यानगर महानगरपालिका,अहिल्यानगर
          </h4>
          <h5 className="text-dark fw-bold">
            Ahilyanagar Municipal Corporation
          </h5>
        </div>
        <div className="col-md-2 align-self-center text-end">
          <Dropdown>
            <MenuButton
              className="bg-dark  text-white ms-3"
              style={{ width: "6rem" }}
            >
              LOGIN
            </MenuButton>
            <Menu className="mt-4">
              <MenuItem>
                <NavLink
                  to="/super-admin"
                  className="dropdown-item text-uppercase "
                >
                  DMC Officer
                </NavLink>
              </MenuItem>

              <MenuItem>
                <NavLink
                  to="/nagar-department"
                  className="dropdown-item text-uppercase "
                >
                  Nagar Rachana Officer
                </NavLink>
              </MenuItem>
              <MenuItem>
                <NavLink
                  to="/divisional-user"
                  className="dropdown-item text-uppercase "
                >
                  Divisional Officer
                </NavLink>
              </MenuItem>
              <MenuItem>
                <NavLink
                  className="dropdown-item text-uppercase"
                  to="/pwd-department"
                >
                  MSEDCL Department
                </NavLink>
              </MenuItem>
              <MenuItem>
                <NavLink
                  className="dropdown-item text-uppercase"
                  to="/police-department"
                >
                  Police Department
                </NavLink>
              </MenuItem>
              <MenuItem>
                <NavLink
                  className="dropdown-item text-uppercase"
                  to="/traffic-police"
                >
                  Traffic Police Department
                </NavLink>
              </MenuItem>
              <MenuItem>
                <NavLink
                  className="dropdown-item text-uppercase"
                  to="/fire-department"
                >
                  Fire Department
                </NavLink>
              </MenuItem>
            </Menu>
          </Dropdown>
        </div>
      </div>
    </div>
  );
};

export default LoginHeader;
